var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"responsive-image-container",staticStyle:{"padding-bottom":"100%"},style:({
            backgroundColor:
                _vm.image.dominantColor && !_vm.image.hasTransparency
                    ? _vm.image.dominantColor
                    : 'transparent',
            paddingBottom: (_vm.image.height / _vm.image.width) * 100 + '%',
        })},[_c('img',{staticClass:"responsive-image img-fluid lazyload lazypreload",attrs:{"data-srcset":_vm.generateSrcSet(_vm.image.sizes),"data-src":_vm.image.default,"src":_vm.image.default,"data-wwf-copyright":_vm.image.copyright,"data-image-id":_vm.image.id,"data-aspectratio":_vm.image.width / _vm.image.height,"srcset":'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==',"data-sizes":"auto","alt":"image.alt"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }